import { Linkable } from '@/components/blocks/Linkable';
import { chipSX, lastBreadcrumbSX } from '@/components/content/BreadcrumbTrail/styles/chip';
import { customBreadcrumbTrailContainerSX } from '@/components/content/BreadcrumbTrail/styles/container';
import { useSettings } from '@/data/Settings';
import { Breadcrumb } from '@/data/types/Breadcrumb';
import { WidgetComponentProps, WidgetProperties } from '@/data/types/Slot';
import { mobileDisplaySx } from '@/styles/mobileApp';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Chip, Link } from '@mui/material';
import { FC, useMemo } from 'react';

const emptyProperties = {} as WidgetProperties;

export const StaticBreadcrumbTrail: FC<WidgetComponentProps> = ({
	properties = { emptyProperties },
}) => {
	const { JSONData: breadcrumbData, id: uniqueId } = properties;
	const { settings } = useSettings();
	const isMobileApp = settings.isMobileApp;

	const breadcrumb: Breadcrumb[] = useMemo(() => {
		if (!breadcrumbData) return [];
		try {
			const normalizedJson = breadcrumbData.replace(/'/g, '"');
			const parsed = JSON.parse(normalizedJson);
			return Object.entries(parsed).map(([label, href]) => {
				const hrefString = href as string;
				return {
					label,
					href: hrefString
						? hrefString.startsWith('/')
							? hrefString
							: `/${hrefString}`
						: undefined,
				};
			});
		} catch (e) {
			console.error('Failed to parse breadcrumb JSON:', e);
			return [];
		}
	}, [breadcrumbData]);
	const breadcrumbLength = breadcrumb.length;

	if (breadcrumbLength === 0) return null;

	return (
		<Breadcrumbs
			sx={{
				...customBreadcrumbTrailContainerSX.container(true),
				...mobileDisplaySx(isMobileApp),
			}}
			separator={<ArrowRightIcon fontSize="small" />}
		>
			<Link
				component={Linkable}
				key={`breadcrumb-${uniqueId}-home`}
				href="/"
				data-testid={`breadcrumb-${uniqueId}-home`}
				id={`breadcrumb-${uniqueId}-home`}
			>
				<Chip avatar={<HomeIcon />} label="Inicio" sx={chipSX} />
			</Link>
			{breadcrumb.map(({ href, label }, index: number) => {
				const isLast = index === breadcrumbLength - 1;

				if (isLast) {
					return (
						<Chip
							key={`breadcrumb-${uniqueId}-${index}-${label}`}
							label={label}
							sx={lastBreadcrumbSX}
							data-testid={`breadcrumb-${uniqueId}-${index}-${label}`}
							id={`breadcrumb-${uniqueId}-${index}-${label}`}
						/>
					);
				}

				return (
					<Link
						component={Linkable}
						key={`breadcrumb-${uniqueId}-${index}-${label}`}
						href={href || '#'}
						sx={chipSX}
						data-testid={`breadcrumb-${uniqueId}-${index}-${label}`}
						id={`breadcrumb-${uniqueId}-${index}-${label}`}
					>
						{label}
					</Link>
				);
			})}
		</Breadcrumbs>
	);
};
